import { call, put, takeLatest, all, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/success';
import { SET_ORDER, POWER_SUMBMIT_LOAD, POWER_SUMBMIT_FAIL } from '../actionTypes/order';
import { GET_POWERS, GET_POWERS_SUCCESS, GET_POWERS_FAIL } from '../actionTypes/editPower';
import config from 'config';
import getSetCookie from '../cookie';
import apiClient from '../helpers/apiClient';
const delay = ms => new Promise(res => setTimeout(res, ms));

let _client = null;
function* getResource(resource, successAction, errorAction) {
    try {
        const client = { ..._client };
        client.setHeader();
        const data = yield call(async () => client.get(resource));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* getPowers({ productId, powerType, isEditPower }) {
    let url = `${config.apiPath.dataProduct}${productId}/powers${powerType && powerType !== 'CONTACT_LENS' ? '?power_type=' + powerType : ''}`;
    '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
    url += powerType && powerType !== 'CONTACT_LENS' ? '&view=consumer' : '';
    '#endif'; // eslint-disable-line
    yield call(getResource, url, { type: isEditPower ? GET_POWERS_SUCCESS : actionTypes.POWERS_DETAIL_SUCCESS, pid: productId, powerType }, { type: isEditPower ? GET_POWERS_FAIL : actionTypes.POWERS_DETAIL_FAIL, pid: productId, powerType });
}

function* getSavedPrescription({ powerType }) {
    const url = `${config.apiPath.getSavedPrescription}${powerType ? '?powerType=' + powerType : ''}`;
    yield call(getResource, url, { type: actionTypes.SAVED_PRESCRIPTION_SUCCESS }, { type: actionTypes.SAVED_PRESCRIPTION_FAIL });
}

function* submitPowers({ itemid, data, userEmail, orderId }) {
    yield put({ type: POWER_SUMBMIT_LOAD });
    const successAction = { type: actionTypes.SUBMIT_POWERS_SUCCESS };
    const errorAction = { type: actionTypes.SUBMIT_POWERS_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        let reqUrl = `${config.apiPath.getOrderDetails}${orderId || getSetCookie.getCookie('orderId')}/items/${itemid}/prescription`;
        if (userEmail !== '') reqUrl = `${reqUrl}?email=${userEmail}`;
        const dataResult = yield call(async () => client.put(reqUrl, data));
        successAction.data = dataResult;
        successAction.itemId = itemid;
        yield put(successAction);
        yield put({ type: SET_ORDER, orderDetails: dataResult });
    } catch (er) {
        errorAction.error = er;
        errorAction.itemId = itemid;
        yield put(errorAction);
        yield put({ type: POWER_SUMBMIT_FAIL, error: er });
    }
}

function* updatePackages({ itemid, data, orderId }) {
    yield delay(100);
    const successAction = { type: actionTypes.SUBMIT_PACKAGE_SUCCESS };
    const errorAction = { type: actionTypes.SUBMIT_PACKAGE_FAIL };
    const client = Object.assign({}, _client);
    client.defaults.headers = {};
    try {
        const reqUrl = `${config.apiPath.getOrderDetails}${orderId || getSetCookie.getCookie('orderId')}/items/${itemid}/package`;
        const dataResult = yield call(async () => client.put(reqUrl, data, {
            headers: {
                'X-Api-Client': 'desktop',
                'Cache-Control': 'no-cache, no-store',
                'X-Auth-Token': '8e8b0816-4c73-4f08-8f7d-022dcd186a91',
                'X-Session-Token': getSetCookie.getCookie('frontend'),
            }
        }));
        successAction.data = dataResult;
        successAction.itemId = itemid;
        yield put(successAction);
        yield put({ type: SET_ORDER, orderDetails: dataResult });
    } catch (er) {
        errorAction.error = er;
        errorAction.itemId = itemid;
        yield put(errorAction);
    }
}

function* getSubmittedPowers({ itemid, userEmail }) {
    let reqUrl = `${config.apiPath.getOrderDetails}${getSetCookie.getCookie('orderId')}/items/${itemid}/prescription`;
    if (userEmail !== '') {
        reqUrl = `${reqUrl}?email=${userEmail}`;
    }
    yield call(getResource, reqUrl, { type: actionTypes.SUBMITTED_POWERS_SUCCESS }, { type: actionTypes.SUBMITTED_POWERS_FAIL });
}

function* getSubmittedOtp({ otp, email }) {
    const successAction = { type: actionTypes.OTP_SUBMISSION_SUCCESS };
    const errorAction = { type: actionTypes.OTP_SUBMISSION_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const reqUrl = `${config.apiPath.getOrderDetails}${getSetCookie.getCookie('orderId')}/otp?value=${otp}&email=${email}`;
        const dataResult = yield call(async () => client.put(reqUrl));
        successAction.data = dataResult;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}


export function* runSuccessCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.POWERS_DETAIL_LOAD, getPowers),
        takeEvery(GET_POWERS, getPowers),
        takeLatest(actionTypes.SAVED_PRESCRIPTION_LOAD, getSavedPrescription),
        takeLatest(actionTypes.SUBMITTED_POWERS_LOAD, getSubmittedPowers),
        takeLatest(actionTypes.SUBMIT_POWERS_LOAD, submitPowers),
        takeLatest(actionTypes.OTP_SUBMISSION_LOAD, getSubmittedOtp),
        takeLatest(actionTypes.SUBMIT_PACKAGE_LOAD, updatePackages)
    ]);
}
